import { Device } from '../models/device.model';
import { MfaDeviceService } from '../services/mfa-device.service';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */
import { Component, ViewEncapsulation, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { catchError } from 'rxjs/operators';

// UI Actions
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'edit-device',
  encapsulation: ViewEncapsulation.Emulated,
  template: require('./edit-device.component.html'),
  styles: [
    `
      .modal .modal-dialog.modal-lg {
        max-width: 400px;
      }
      .modal-title {
        font-weight: 400;
      }
    `,
  ],
})
export class EditDeviceComponent {
  @ViewChild('editDevice') editDeviceTemplate: ElementRef;
  @Output() rowsUpdated: EventEmitter<any> = new EventEmitter<any>();

  public editModalLoading: boolean = false;
  public editDeviceStatus: string;
  public deviceNickname: string;
  public editStep: number;
  public selectedDevice: Device;

  constructor(private modalService: NgbModal, private mfaDeviceService: MfaDeviceService) {}

  public editDeviceModal(row: Device) {
    this.editDeviceStatus = null;
    this.selectedDevice = row;
    this.deviceNickname = null;

    this.modalService
      .open(this.editDeviceTemplate, {
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        () => {},
        () => {}
      );
  }

  public setDeviceAlias(deviceNickname: string) {
    this.deviceNickname = deviceNickname;

    if (deviceNickname) {
      this.editModalLoading = true;
      this.mfaDeviceService.putEditDevice(this.selectedDevice, this.deviceNickname).subscribe(
        (response) => {
          this.editDeviceStatus = 'success';
          this.editModalLoading = false;
          this.rowsUpdated.emit([response]);
        },
        (err: any) => {
          this.editDeviceStatus = 'error';
          this.editModalLoading = false;
        }
      );
    }
  }

  public retryEdit() {
    this.editStep = 1;
    this.editDeviceStatus = null;
    this.deviceNickname = null;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/manage-mfa-device/edit-device/edit-device.component.ts